export default {
	listOfDeals:        [],
};
